// extracted by mini-css-extract-plugin
export default {"row-nequi":"row-nequi__KMCDh","table-data-nequi":"table-data-nequi__P3oPS","property":"property__a9E9M","property-nequi":"property-nequi__0u2OT","value-nequi":"value-nequi__aEZ9v"};